import React from 'react';
import CardContainerForDevelopment from '../../Components/CardContainerForDevelopment/CardContainerForDevelopment';
import style from './Desarrollo.module.css'

const Desarrollos = () => {
  return (
    <div className={style.container}>
      <CardContainerForDevelopment />
    </div>
  );
};

export default Desarrollos;
